import * as angular from 'angular';
import * as template from './template.html';
import './styling.scss';
import { IAugmentedJQuery } from 'angular';
import { isEligibleForWindCoverage } from 'common/source/utilities/policyInfoHelper';

const module = angular.module('add-wind-coverage-section', []);

interface AddWindCoverageSectionController extends angular.IStrictController {
    title: string;
    description: string;
    icon: string;
    policyInfo: CustomerPolicyInfo;
    forceWindExclusion: boolean;
}

module.component('addWindCoverageSection', {
    template: template,
    bindings: {
        policyInfo: '<'
    },
    controller: function(this: AddWindCoverageSectionController, $element: IAugmentedJQuery) {
        this.$onInit = () => {
            this.title = 'Add wind coverage';
            this.description = `We always do our best to cover all things you care about most and would be happy to
                provide you with additional coverage for wind, hail and hurricane damage through one of our 3rd party
                partners. Please call us at 1-800-585-0705 or click below.`;
            this.icon = 'wind';

            if (!isEligibleForWindCoverage(this.policyInfo)) {
                $element.addClass('ng-hide');
            }
        };
    }
});

export { module };
